<template>
  <v-col>
    <v-sheet height="64">
      <v-toolbar flat>
        <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">
          Heute
        </v-btn>
        <v-btn fab text small color="grey darken-2" @click="prev">
          <v-icon small> mdi-chevron-left </v-icon>
        </v-btn>
        <v-btn fab text small color="grey darken-2" @click="next">
          <v-icon small> mdi-chevron-right </v-icon>
        </v-btn>
        <v-toolbar-title v-if="$refs.calendar">
          {{ $refs.calendar.title }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-menu bottom right>
          <template v-slot:activator="{ on, attrs }">
            <v-btn outlined color="grey darken-2" v-bind="attrs" v-on="on">
              <span>{{ typeToLabel[type] }}</span>
              <v-icon right> mdi-menu-down </v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="type = 'month'">
              <v-list-item-title>Monat</v-list-item-title>
            </v-list-item>
            <v-list-item @click="type = 'week'">
              <v-list-item-title>Woche</v-list-item-title>
            </v-list-item>
            <v-list-item @click="type = 'category'">
              <v-list-item-title>Tag</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar>
    </v-sheet>
    <v-sheet height="600">
      <v-calendar
        ref="calendar"
        v-model="focus"
        color="primary"
        locale="de"
        first-time="08:00"
        :events="events"
        :type="type"
        category-show-all
        :interval-count="16"
        :categories="categories"
        :event-color="getEventColor"
        event-text-color="black"
        :weekdays="weekday"
        @click:more="viewDay"
        @click:event="viewEventDay"
        @click:date="viewDay"
      >
        <template v-slot:day-body="{ weekday }">
          <template v-if="![0, 6].includes(weekday)">
            <v-sheet
              class="striped overlay"
              height="100%"
              width="100%"
              :style="{ top: LTA }"
            >
              <div class="text-center">
                <h4 class="mt-6">LTA & FCB Training</h4>
                <p>
                  Anlage möglicherweise eingeschränkt verfügbar. Hauptfeld
                  gesperrt.
                </p>
              </div></v-sheet
            >
          </template>
          <template v-if="[0, 6].includes(weekday)">
            <v-sheet
              class="overlay striped"
              height="100%"
              width="100%"
              :style="{ top: FCB.saso }"
            >
              <div class="text-center">
                <h4 class="mt-6">FCB Spiele</h4>
                <p>Hauptfeld gesperrt.</p>
              </div></v-sheet
            >
          </template>
        </template>
      </v-calendar>
    </v-sheet>
  </v-col>
</template>
<script>
// Mixins
import fetchEvents from "@/mixins/fetchEvents";
import eventCategories from "@/mixins/eventCategories";

export default {
  mixins: [fetchEvents, eventCategories],
  data: () => ({
    focus: "",
    type: "week",
    typeToLabel: {
      month: "Monat",
      week: "Woche",
      category: "Tag",
    },
    weekday: [1, 2, 3, 4, 5, 6, 0],
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    value: "",
    ready: false,
  }),
  computed: {
    cal() {
      return this.ready ? this.$refs.calendar : null;
    },
    LTA() {
      return this.cal ? this.cal.timeToY("18.00") + "px" : "";
    },
    FCB() {
      const Sperrzeit = {
        saso: this.cal ? this.cal.timeToY("13.00") + "px" : "",
      };
      return Sperrzeit;
    },
  },
  mounted() {
    this.ready = true;
    this.$refs.calendar.checkChange();
  },
  methods: {
    viewDay({ date }) {
      this.focus = date;
      this.type = "category";
    },
    viewEventDay(event) {
      this.focus = event.eventParsed.start.date;
      this.type = "category";
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    getEventColor(event) {
      return event.category;
    },
    getCurrentTime() {
      return this.cal
        ? this.cal.times.now.hour * 60 + this.cal.times.now.minute
        : 0;
    },
    scrollToTime() {
      const time = this.getCurrentTime();
      const first = Math.max(0, time - (time % 30) - 30);
      this.cal.scrollToTime(first);
    },
    updateTime() {
      setInterval(() => this.cal.updateTimes(), 60 * 1000);
    },
  },
};
</script>
<style lang="scss">
.v-current-time {
  height: 2px;
  background-color: #ea4335;
  position: absolute;
  left: -1px;
  right: 0;
  pointer-events: none;

  &.first::before {
    content: "";
    position: absolute;
    background-color: #ea4335;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-top: -5px;
    margin-left: -6.5px;
  }
}

.theme--light.v-calendar-daily .v-calendar-daily_head-day, .v-calendar-daily__intervals-body, .v-calendar-daily__intervals-head {
  background: white;
}

.overlay {
  left: 0;
  top: 0;
  position: absolute;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.overlay.header {
  z-index: -1;
}

.striped {
  opacity: 0.58;
  background: repeating-linear-gradient(
    45deg,
    transparent,
    transparent 10px,
    #f2f2f2 0,
    #f2f2f2 20px
  );
}

.v-calendar .v-event-timed {
  font-size: 15px !important;
  z-index: 1;
}

.v-calendar .v-event-timed-container {
  margin: 10px;
}

.v-calendar-category__column {
  overflow: hidden;
}
</style>